import { render, staticRenderFns } from "./title.module.vue?vue&type=template&id=341aa513&scoped=true"
import script from "./title.module.vue?vue&type=script&lang=js"
export * from "./title.module.vue?vue&type=script&lang=js"
import style0 from "./title.module.vue?vue&type=style&index=0&id=341aa513&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341aa513",
  null
  
)

export default component.exports